import { useEffect, useState } from 'react';

// Indicates that the DNS query was unable to find any records for the specified domain. This is known as a NXDOMAIN (Non-Existent Domain) error.
export const NXDOMAIN_ERROR_CODE = 3;

export const useCanResolveDomain = ({
  websiteURL,
  initialValue = true,
}: {
  websiteURL: string;
  initialValue?: boolean;
}) => {
  const [canResolveDomain, setCanResolveDomain] = useState(initialValue);

  useEffect(() => {
    (async () => {
      try {
        // Checking if domain name can be resolved, https://developers.google.com/speed/public-dns/docs/doh/json
        const response = await fetch(
          `https://dns.google/resolve?name=${websiteURL}`,
        );
        const json = await response.json();
        if (json.Status === NXDOMAIN_ERROR_CODE) {
          setCanResolveDomain(false);
        }
      } catch (err) {}
    })();
  }, [websiteURL]);

  return {
    canResolveDomain,
  };
};
